import type { SimpleAggregation } from '@core/Entities/Search/Aggregations/Aggregations.entity';
import type { DropdownOptionProps } from '@gds/Dropdown/Components/DropdownOption.types';
import type { PriceItemAtom } from '@search/Atoms/PriceItemAtom.entity';

export const getPriceOptionsWithAggs = (
  filterOptions: DropdownOptionProps[],
  aggregations: SimpleAggregation,
): PriceItemAtom[] => {
  const buckets = Object.entries(aggregations)
    .map(([price, count]) => ({ price: Number(price), count }))
    .filter(({ price, count }) => Number.isFinite(price) && count > 0)
    .sort((first, second) => first.price - second.price);
  const sortedOptions = filterOptions
    .map(option => ({ option, price: Number(option.value) }))
    .filter(({ price }) => Number.isFinite(price))
    .sort((first, second) => first.price - second.price);

  let bucketIndex = 0;
  let cumulativeCount = 0;

  return sortedOptions.flatMap(({ option, price }) => {
    while (bucketIndex < buckets.length && buckets[bucketIndex].price < price) {
      cumulativeCount += buckets[bucketIndex].count;
      bucketIndex += 1;
    }

    if (cumulativeCount === 0) return [];

    return [
      {
        key: String(option.value),
        displayName: option.label,
        count: cumulativeCount,
      },
    ];
  });
};
